export const measurementsSelector = state => state.measurements.measurements;

export const measurementsLoadingSelector = state => state.measurements.isLoading;

export const measurementsErrorsSelector = state => state.measurements.error;
